"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Clock, Users, Brain, Search, Briefcase } from "lucide-react";

const problems = [
  {
    icon: Clock,
    title: "Ore di data entry ogni giorno",
    description:
      "Trascorri 2-3 ore al giorno a trascrivere ordini e fatture a mano, invece di visitare clienti.",
  },
  {
    icon: Users,
    title: "Clienti dimenticati nel caos di Excel",
    description:
      "Senza un sistema centralizzato, clienti importanti finiscono nel dimenticatoio per mesi.",
  },
  {
    icon: Brain,
    title: "Decisioni a intuito, senza dati",
    description:
      "Pianifichi il giro visite a memoria, senza sapere chi ha ordinato e chi ha saltato la stagione.",
  },
  {
    icon: Search,
    title: "Difficoltà a trovare nuovi clienti",
    description:
      "Il prospecting è costoso e frustrante. Non sai dove cercare né come approcciare.",
  },
  {
    icon: Briefcase,
    title: "Portfolio brand difficile da gestire",
    description:
      "Decine di mandanti, prezzi che cambiano, offerte perse perché non avevi quel marchio.",
  },
];

export function ProblemSection() {
  return (
    <section className="py-20 md:py-32 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-ruby-600 mb-4">
            Il problema
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-mocha-950 tracking-tight mb-4">
            Le 5 fatiche dell&apos;agente di commercio moderno
          </h2>
          <p className="text-lg text-mocha-600 max-w-2xl mx-auto">
            Se ti riconosci in anche solo 3 di queste situazioni, KennyDB è fatto per te.
          </p>
        </div>

        {/* Problem Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {problems.map((problem, index) => (
            <Card
              key={problem.title}
              className={`group border-ruby-100 hover:border-ruby-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
                index >= 3 ? "md:col-span-1 md:col-start-2" : ""
              } ${index === 3 ? "md:col-start-1" : ""}`}
            >
              <CardContent className="p-6 md:p-8">
                <div className="w-12 h-12 rounded-xl bg-ruby-50 flex items-center justify-center mb-5 group-hover:bg-ruby-100 transition-colors">
                  <problem.icon className="w-6 h-6 text-ruby-600" />
                </div>
                <h3 className="font-serif text-xl font-semibold text-mocha-950 mb-3">
                  {problem.title}
                </h3>
                <p className="text-mocha-600 leading-relaxed">
                  {problem.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
